import { render, staticRenderFns } from "./ViPaymentHistory.vue?vue&type=template&id=98bb66f0&scoped=true"
import script from "./ViPaymentHistory.vue?vue&type=script&lang=js"
export * from "./ViPaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./ViPaymentHistory.vue?vue&type=style&index=0&id=98bb66f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bb66f0",
  null
  
)

export default component.exports